import { takeLatest, call, put } from 'redux-saga/effects';
import memberAdminNoSessionApi from 'api/employee/memberAdminNoSessionApi';
import * as serviceDeskActions from 'redux/ducks/serviceDesk/serviceDeskDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getRegion({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getRegion, payload);
    yield put(serviceDeskActions.getRegionSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getCompany({ payload }) {
  try {
    const response = yield call(memberAdminNoSessionApi.getCompany, payload);
    yield put(serviceDeskActions.getCompanySuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* serviceDeskSaga() {
  yield takeLatest(serviceDeskActions.getRegion, getRegion);
  yield takeLatest(serviceDeskActions.getCompany, getCompany);
}
